export const PRODUCT_CODE = {
  DMP: "dmp",
  DMX: "dmx",
  DHE: "dhe",
};
